export default __webpack_public_path__ + "static/media/PaymentIn60Mins.0c959b57.svg";